import { createStyles } from '@mui/styles';

// Types
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
  formControlCls: {
    width: '200px',
    backgroundColor: '#ffffff',
    textAlign: 'left',
    '& label': {
      fontSize: '16px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '0',
      letterSpacing: '-0.5px',
      color: '#cccccc',
      overflow: 'visible'
    },
    '& .MuiNativeSelect-icon': {
      right: '15px',
      top: 'calc(50% - 9px)',
      height: '18px',
      width: '18px'
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 14px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -1px) scale(0.75)'
    }
  },
  commissionFormControlCls: {
    borderRadius: 3,
    border: 'solid 1px #cccccc',
    '& .MuiSelect-nativeInput': {
      padding: 0,
      border: 'none'
    },
    '& .MuiInputBase-input': {
      borderRadius: 3,
      paddingLeft: 20,
      height: 16,
      minHeight: 16
    },
    '& .MuiSelect-icon': {
      paddingRight: 6
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0
    },
    '@media(max-width: 570px)': {
      width: '100%'
    },
  },
  openCommissionDropdown: {
    border: 'solid 1px #2D91E9',
    borderBottom: 'none',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  menuItem: {
    margin: '3px 10px',
    borderRadius: 3,
    '&.MuiMenuItem-root.Mui-selected, &.MuiListItem-root.Mui-selected:hover': {
      color: '#fff',
      backgroundColor: '#2D91E9'
    },
  },
  commissionMenuItem: {
    margin: '2px 20px',
    lineHeight: '18px',
    '&.MuiMenuItem-root:hover': {
      color: '#4A4A4A',
      backgroundColor: '#EAF3FF'
    },
    '&.MuiMenuItem-gutters': {
      padding: 10
    }
  },
  selectMenuPopper: {
    boxShadow: 'none',
    border: 'solid 1px #2D91E9',
    borderRadius: '0 0 3px 3px',
    borderTop: 'none',
    '@media(min-width: 570px)': {
      minWidth: '200px'
    },
  },
  customAccountPopper: {
    width: 400,
    '@media(max-width: 990px)': {
      width: 'auto'
    },
    border: 'none',
    '& .MuiMenu-list': {
      padding: '4px 16px 12px 16px',
      border: '1.5px solid #2D91E9',
      borderTop: 'none',
      borderRadius: '0px 0px 4px 4px',
      boxShadow: 'none',
      maxHeight: '70vh',
      '& .MuiMenuItem-root': {
        padding: '12px 16px',
        borderRadius: 4,
        margin: '0px 0px 4px 0px',
        '& li': {
          width: '100%',
          alignItems: 'center',
          '&:last-child': {
            marginBottom: 0
          },
          '& > img': {
            height: 20,
            width: 20
          },
          '& > div > div:last-child': {
            fontSize: '1rem',
            fontWeight: 400
          },
          '&[aria-selected="true"]': {
            color: '#FFFFFF',
            backgroundColor: '#2D91E9 !important'
          },
          '&[aria-selected="false"]': {
            '& > div:last-child': {
              display: 'none'
            }
          },
          '&.Mui-focused': {
            backgroundColor: '#EAF3FF'
          }
        }
      }
    }
  },
  commissionStatementMenuItem: {
    margin: 0,
    borderRadius: 0,
    '&.MuiMenuItem-root.Mui-selected $secondSection': {
      color: '#fff'
    },
    '&.MuiMenuItem-root.Mui-selected:hover $secondSection': {
      color: '#fff'
    }
  },
  secondSection: {
    color: '#A4A4A4',
  },
  accountSelectDropdown: {
    width: 400,
    '@media(max-width: 990px)': {
      width: '-webkit-fill-available'
    },
    '& .expanded': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderBottom: 'none',
        borderWidth: '1px',
        borderRadius: '4px 4px 0px 0px'
      }
    },
    'input': {
      userSelect: 'none'
    },
    '& .MuiSelect-select': {
      padding: '8px 16px',
      '& li': {
        alignItems: 'center',
        height: '40px',
        '& div': {
          '&:first-child': {
            lineHeight: '24px'
          },
          '&:last-child': {
            display: 'none'
          }
        },
        'li &:last-child': {
          display: 'none'
        }
      }
    }
  }
});
